import { CompanyFilterBaseDataProvider } from './CompanyFilterBaseDataProvider';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class CompanyFilterNirvanaDataProvider extends CompanyFilterBaseDataProvider {
  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    try {
      const response = await this.dependencies.api.clients.Alerts.getInitialTargets(
        request,
        getRequestDefaultOptions()
      ).toPromise();

      return response;
    } catch (e) {
      throw new Error(e);
    }
  }

  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const response = await this.dependencies.api.clients.ProtectedEntities.getCompanies(
        request,
        getRequestDefaultOptions()
      ).toPromise();

      return response;
    } catch (e) {
      throw new Error(e);
    }
  }
}
